

























































































































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  ALL_OFFICES_BY_CUSTOMER,
  ALL_REMINDERS_BY_CUSTOMER,
  CREATE_REMINDERS,
  CUSTOMER_DETAILS,
  DELETE_REMINDERS,
  GET_ALL_REMINDERS_BY_CUSTOMER,
  OPEN_CREATE_REMINDERS_MODAL,
  OPEN_CREATE_REMINDERS_MODAL_ERRORS,
  SET_OPEN_CREATE_REMINDERS_MODAL,
  SET_OPEN_CREATE_REMINDERS_MODAL_ERRORS,
} from '@/types/customer.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Grid } from '@/models/Grid.model';
import { GridColumn } from '@/models/GridColumn.model';
import { CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';
import { ClickColumn } from '@/models/ClickColumn.model';
import { DeleteRemindersRequest } from '@/models/backoffice/DeleteRemindersRequest';
import { CreateRemindersRequest } from '@/models/backoffice/CreateRemindersRequest';
import Mock from '@/globals/backoffice.mock';
import { CreateMailReminderModel } from '@/models/backoffice/CreateMailReminderModel';
import { Utils } from '@/globals/Utils';

@Component({})
export default class RemindersSettingsComponent extends Vue {
  @Inject() public $validator: any;

  @Action(GET_ALL_REMINDERS_BY_CUSTOMER, StoreNamespace.CUSTOMER) public getAllRemindersByCustomer;
  @Action(DELETE_REMINDERS, StoreNamespace.CUSTOMER) public deleteReminders;
  @Action(CREATE_REMINDERS, StoreNamespace.CUSTOMER) public createReminders;

  @Mutation(SET_OPEN_CREATE_REMINDERS_MODAL, StoreNamespace.CUSTOMER) public setOpenCreateRemindersModal;
  @Mutation(SET_OPEN_CREATE_REMINDERS_MODAL_ERRORS, StoreNamespace.CUSTOMER) public setOpenCreateRemindersModalErrors;

  @Getter(ALL_REMINDERS_BY_CUSTOMER, StoreNamespace.CUSTOMER) public allRemindersByCustomer!: Grid;
  @Getter(ALL_OFFICES_BY_CUSTOMER, StoreNamespace.CUSTOMER) public allOfficesByCustomer!: Grid;
  @Getter(CUSTOMER_DETAILS, StoreNamespace.CUSTOMER) public customerDetails!: CustomerDetailsModel;
  @Getter(OPEN_CREATE_REMINDERS_MODAL, StoreNamespace.CUSTOMER) public openCreateRemindersModel!: boolean;
  @Getter(OPEN_CREATE_REMINDERS_MODAL_ERRORS, StoreNamespace.CUSTOMER)
  public openCreateRemindersModelErrors!: string[];

  public createMailReminder: CreateRemindersRequest = {} as CreateRemindersRequest;
  public columns: GridColumn[] = [];
  public remindersMock: any = {};
  public selectedHour: string = '';
  public noticeSendDate: Date = new Date();
  public openDeleteReminderModal: boolean = false;
  private deleteRemindersRequest: DeleteRemindersRequest = {} as DeleteRemindersRequest;

  public destroyed() {
    this.setOpenCreateRemindersModal(false);
  }

  public created() {
    this.createMailReminder = {
      officeNums: [],
      indexNum: this.customerDetails.indexNum,
      createMailReminderModel: {
        noticeSendDate: '',
        sendReminderByEmailFlag: true,
        sendReminderBySmsFlag: false,
      } as CreateMailReminderModel,
    } as CreateRemindersRequest;
  }

  public mounted() {
    this.remindersMock = Mock.reminders;
    this.setOpenCreateRemindersModal(false);
    this.getAllRemindersByCustomer(this.customerDetails.indexNum);
    this.initColumns();
  }

  public initColumns() {
    this.columns.push({
      property: 'indexNum',
      header: 'back_office.settings.reminders.indexNum',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'officeNum',
      header: 'back_office.settings.reminders.officeNum',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'officeName',
      header: 'back_office.settings.reminders.officeName',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'reminderTypeDesc',
      header: 'back_office.settings.reminders.reminderType',
      hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'sendReminderByEmailFlag',
      header: 'back_office.settings.reminders.sentViaEmail',
      hideSorting: true,
      booleanProperty: true,
      trueValue: '✓',
      falseValue: '✗',
    } as GridColumn);
    this.columns.push({
      property: 'sendReminderBySmsFlag',
      header: 'back_office.settings.reminders.sentViaSms',
      hideSorting: true,
      booleanProperty: true,
      trueValue: '✓',
      falseValue: '✗',
    } as GridColumn);
    this.columns.push({
      property: 'noticeSendDate',
      header: 'back_office.settings.reminders.noticeSendDate',
      hideSorting: true,
      direction: 'ltr',
    } as GridColumn);
    this.columns.push({
      clickEvent: 'DELETE',
      mdIcon: 'delete',
      header: 'back_office.settings.reminders.delete',
    } as ClickColumn);
  }

  public onTdClicked(item, column) {
    switch (column.clickEvent) {
      case 'DELETE':
        this.openDeleteReminderModal = true;
        this.deleteRemindersRequest = {
          indexNum: this.customerDetails.indexNum,
          ids: [item.id],
        };
        break;
    }
  }

  public addReminders() {
    this.noticeSendDate = new Date();
    this.selectedHour = '';
    this.createMailReminder = {
      officeNums: [],
      createMailReminderModel: {
        noticeSendDate: this.noticeSendDate.setHours(8).toString(),
        sendReminderByEmailFlag: true,
        sendReminderBySmsFlag: false,
      } as CreateMailReminderModel,
    } as CreateRemindersRequest;
    this.setOpenCreateRemindersModal(true);
    this.setOpenCreateRemindersModalErrors([]);
  }

  public updateReminderHour(hour) {
    if (hour) {
      this.noticeSendDate.setHours(hour, 0, 0, 0);
    }
  }

  public onCreateReminders() {
    if (!this.createMailReminder.createMailReminderModel.sendReminderByEmailFlag &&
        !this.createMailReminder.createMailReminderModel.sendReminderBySmsFlag) {
      this.setOpenCreateRemindersModalErrors([
        this.$t('back_office.settings.reminders.errorAtLeastOneSendType').toString(),
      ]);
      return;
    }
    this.$validator.validateAll('createRemindersForm').then((result: any) => {
      if (!result) {
        setTimeout(() => {
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
      } else {
        this.createMailReminder.createMailReminderModel.noticeSendDate = Utils.FullDateToString(this.noticeSendDate);
        this.createMailReminder.indexNum = this.customerDetails.indexNum;
        this.createMailReminder.createMailReminderModel.indexNum = this.customerDetails.indexNum;
        this.createReminders(this.createMailReminder);
      }
    });
  }

  public closeModal() {
    this.setOpenCreateRemindersModal(false);
  }

  public onOfficeNums(item: any) {
    if (item) {
      this.createMailReminder.officeNums = item;
    }
  }

  public onReminderType(item: any) {
    if (item) {
      this.createMailReminder.createMailReminderModel.reminderType = item;
    }
  }

  public onSendReminderBy(createMailReminderModel: CreateMailReminderModel) {
    this.createMailReminder.createMailReminderModel = createMailReminderModel;
  }

  public closeDeleteReminderModal() {
    this.openDeleteReminderModal = false;
    this.deleteRemindersRequest = {} as DeleteRemindersRequest;
  }

  public onDeleteReminderClicked() {
    this.deleteReminders(this.deleteRemindersRequest);
    this.closeDeleteReminderModal();
  }

}

